var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9048 9.68841C14.9382 10.2643 14.942 10.9887 13.9048 11.6398L5.89081 17.0446C4.88386 17.582 4.19997 17.2647 4.12818 16.1019L4.09418 4.78978C4.07151 3.71872 4.95376 3.41611 5.79446 3.92963L13.9048 9.68841Z",
    stroke: "#141F35",
    strokeWidth: 2.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.15ce539697d163b48d927923436b129e.svg";
export { ForwardRef as ReactComponent };